export const REGISTRO_EXITOSO = "REGISTRO_EXITOSO";
export const REGISTRO_ERROR = "REGISTRO_ERROR";
export const OBTENER_USUARIO = "OBTENER_USUARIO";
export const LOGIN_EXITOSO = "LOGIN_EXITOSO";
export const LOGIN_ERROR = "LOGIN_ERROR";
export const CERRAR_SESION = "CERRAR_SESION";

export const OBTENER_GASTOS = "OBTENER_PROYECTOS";
export const OBTENER_GASTOS_USUARIO = "OBTENER_PROYECTOS_USUARIO";
export const AGREGAR_GASTO = "AGREGAR_PROYECTO";
export const VALIDAR_GASTO = "VALIDAR_FORMULARIO";
export const GASTO_ACTUAL = "PROYECTO_ACTUAL";
export const ELIMINAR_GASTO = "ELIMINAR_PROYECTO";
export const GASTO_ERROR = "PROYECTO_ERROR";
export const ACTUALIZAR_GASTO = "ACTUALIZAR_GASTO";

export const GASTO_SIMPLE = "SIMPLE";
export const GASTO_URGENTE = "URGENTE";
export const GASTO_AVISO = "AVISO";

export const OCULTAR_ALERTA = "AVISO";
export const MOSTRAR_ALERTA = "AVISO";
